import { render, staticRenderFns } from "./GatewayEdit.vue?vue&type=template&id=381251bf&scoped=true"
import script from "./GatewayEdit.vue?vue&type=script&lang=js"
export * from "./GatewayEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381251bf",
  null
  
)

export default component.exports